import { faSortUp } from '@fortawesome/pro-duotone-svg-icons/faSortUp'
import { faSortDown } from '@fortawesome/pro-duotone-svg-icons/faSortDown'
import { faSort } from '@fortawesome/pro-duotone-svg-icons/faSort'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'

const icons: IconDefinition[] = [faSortUp, faSortDown, faSort] as IconDefinition[]

export default icons